const showSalesPopup = state => state.showSalesPopup;

const showThematicBanner = state => state.showThematicBanner;

const showLibraryBanner = state => state.showLibraryBanner;

const showIslandBanner = state => state.showIslandBanner;

export default {
  showSalesPopup,
  showThematicBanner,
  showLibraryBanner,
  showIslandBanner,
};
